import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomButtonComponent } from '../custom-components/custom-button/custom-button.component';
import { CustomInputNumberComponent } from '../custom-components/custom-input-number/custom-input-number.component';

@Component({
  selector: 'app-custom-initial-consecutive',
  templateUrl: './custom-initial-consecutive.component.html',
  styleUrls: ['./custom-initial-consecutive.component.scss'],
  standalone: true,
  imports: [CustomInputNumberComponent, CustomButtonComponent, ReactiveFormsModule]
})
export class CustomInitialConsecutiveComponent {

  form: FormGroup = new FormGroup({});
  // no se usa se comenta para pruebas unitarias
  // subscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    public ref: DynamicDialogRef,
    private toastHandlerService: ToastHandlerService) {
    this.form = this.formBuilder.group({
      consecutive: [null, [Validators.required, Validators.min(1)]]
    });
  }

  // no se usa se comenta para pruebas unitarias
  // ngOnDestroy(): void {
  //   this.subscription?.unsubscribe();
  // }

  send(): void {
    if (this.form.invalid) {
      this.showValidationMessages();
      return;
    }

    const output$ = this.config.data?.output$;
    output$?.next({ type: 'initialConsecutive', payload: this.form.value });
    this.ref.close(this.form.value);
  }

  private showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      consecutive: {
        required: 'Debe ingresar el número de documento.',
        min: 'El número de documento debe ser mayor a 0.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.form.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }
}
